var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgManropeV13LatinRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Manrope",
    horizAdvX: 1131
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Manrope ExtraLight",
    unitsPerEm: 2000,
    panose1: "0 0 0 0 0 0 0 0 0 0",
    ascent: 2132,
    descent: -600,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 627,
    d: "M240 0V165H387V0H240ZM240 360V1440H387V360H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 784,
    d: "M120 1080V1440H267V1080H120ZM437 1080V1440H584V1080H437Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 1841,
    d: "M411 1L527 434H120L157 575H565L650 896H243L281 1037H689L796 1440H943L834 1037H1169L1276 1440H1423L1314 1037H1721L1683 896H1277L1190 575H1597L1559 434H1153L1037 1H891L1006 434H673L557 1H411ZM711 575H1045L1130 896H797L711 575Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 1178,
    d: "M520 -197V31H667V-197H520ZM520 1410V1639H667V1410H520ZM611 -30Q468 -30 354 21T165 165T67 385L210 410Q243 272 352 192T617 111Q774 111 871 187T968 388Q968 480 914 535T731 629L411 729Q121 820 121 1073Q121 1191 179 1280T342 1420T587 1469Q724 1469 832 1418T1011 1272T1104 1049L957 1021Q943 1113 893 1182T763 1289T587 1329Q495 1329 423 1297T310 1209T268 1079Q268 999 325 944T508 850L783 767Q957 715 1034 627T1111 392Q1111 265 1049 170T875 23T611 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 1803,
    d: "M280 0L180 100L1523 1440L1623 1341L280 0ZM1323 -30Q1224 -30 1143 18T1012 148T963 330Q963 428 1013 510T1145 641T1323 690Q1422 690 1504 642T1634 512T1683 330Q1683 230 1635 149T1504 19T1323 -30ZM1323 103Q1384 103 1436 134T1519 216T1550 330Q1550 392 1519 443T1436 526T1323 557Q1261 557 1210 526T1127 444T1095 330Q1095 268 1126 217T1209 134T1323 103ZM480 750Q381 750 299 798T169 928T120 1110Q120 1208 170 1290T302 1421T480 1470Q579 1470 660 1422T791 1292T840 1110Q840 1010 791 929T661 799T480 750ZM480 883Q542 883 593 914T676 996T707 1110Q707 1172 676 1223T594 1306T480 1337Q418 1337 367 1306T284 1224T253 1110Q253 1048 284 997T366 914T480 883Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 1303,
    d: "M603 -30Q483 -30 381 4T209 113Q155 171 129 242T100 394Q99 470 122 545T194 678Q223 714 259 738T335 779Q260 857 221 923T181 1087Q181 1198 237 1290T394 1427Q445 1450 498 1459T605 1469Q686 1469 764 1447T897 1376Q934 1347 962 1308T1006 1225L864 1183Q843 1237 794 1274Q756 1304 707 1316T607 1328Q522 1328 453 1295Q393 1265 363 1212T333 1088Q333 1027 353 988T411 902Q433 878 460 854T515 803L971 380Q975 408 976 434T977 487L976 698H1115V477Q1115 398 1109 348T1093 265L1279 94L1182 -9L1023 141Q990 98 940 64T839 11Q785 -13 725 -21T603 -30ZM605 112Q662 112 708 119T796 148Q849 176 875 200T917 244L449 672Q407 659 371 637T308 583Q279 547 265 500T251 401Q253 346 269 300T319 217Q366 162 445 137T605 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 427,
    d: "M120 1080V1440H267V1080H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 852,
    d: "M657 -359Q539 -224 455 -58T325 292T280 660Q279 845 324 1028T454 1378T657 1679L765 1595Q649 1456 571 1304T455 989T415 660Q416 495 455 332T572 15T765 -273L657 -359Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 852,
    d: "M195 -359L87 -273Q202 -139 279 14T396 331T437 660Q436 827 398 989T281 1303T87 1595L195 1679Q313 1544 397 1378T527 1029T572 660Q573 475 528 292T398 -57T195 -359Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 873,
    d: "M259 779L149 859L307 1063L60 1138L102 1267L345 1181L339 1440H475L469 1181L711 1267L753 1138L507 1063L663 859L553 779L407 991L259 779Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 1153,
    d: "M514 263V657H120V783H514V1177H640V783H1033V657H640V263H514Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 531,
    d: "M120 -209L129 -136Q169 -139 187 -120T209 -69T211 0H120V211H291V-40Q291 -132 245 -178T120 -209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 840,
    d: "M120 567V693H720V567H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 507,
    d: "M168 0V171H339V0H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 775,
    d: "M504 1440H655L271 0H120L504 1440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 1220,
    d: "M610 -30Q477 -30 371 32T202 200T140 440V1000Q140 1133 202 1239T370 1408T610 1470Q743 1470 849 1408T1018 1240T1080 1000V440Q1080 307 1018 201T850 32T610 -30ZM610 112Q699 112 772 155T888 272T931 433V1007Q931 1096 888 1169T772 1285T610 1329Q521 1329 448 1286T332 1169T289 1007V433Q289 345 332 272T448 156T610 112Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 780,
    d: "M391 0V1276L120 1113V1278L391 1440H540V0H391Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 1140,
    d: "M100 1L101 135L752 723Q836 799 863 867T891 1011Q891 1100 849 1172T736 1286T577 1329Q485 1329 413 1285T300 1169T259 1012H109Q109 1143 171 1247T339 1410T579 1470Q710 1470 814 1409T979 1243T1040 1010Q1040 920 1019 852T952 725T836 604L258 82L235 142H1040V1H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 1106,
    d: "M527 -29Q420 -29 330 9T175 117T80 286L220 328Q256 221 338 166T525 113Q621 115 690 156T797 270T834 439Q834 586 749 675T523 765Q484 765 441 755T361 725L287 842L847 1359L871 1299H137V1440H969V1297L481 831L479 889Q629 908 743 855T921 694T986 439Q986 301 927 196T763 31T527 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 1179,
    d: "M774 0V279H100V419L582 1440H747L265 419H774V839H922V419H1079V279H922V0H774Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 1155,
    d: "M565 -30Q453 -30 358 16T196 143T100 329L241 367Q260 289 310 233T427 145T569 114Q665 114 741 160T863 284T908 453Q908 548 861 624T737 746T569 791Q467 791 393 747T275 635L141 691L185 1440H954V1299H250L323 1368L284 729L247 778Q309 849 397 889T582 929Q715 929 822 866T992 694T1055 453Q1055 321 988 212T810 36T565 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 1241,
    d: "M627 -30Q492 -30 382 35T206 213T140 467V966Q140 1111 205 1224T382 1403T638 1469Q761 1469 866 1415T1039 1264L926 1171Q880 1243 804 1286T638 1329Q537 1329 458 1280T334 1152T289 979V665L252 707Q315 806 417 867T641 928Q775 928 882 865T1052 693T1115 451Q1115 318 1049 209T872 35T627 -30ZM627 113Q721 113 798 158T921 280T967 451Q967 545 922 622T799 745T628 791Q534 791 457 746T335 623T289 451Q289 358 334 281T456 159T627 113Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 1004,
    d: "M217 0L747 1297H80V1440H904V1297L375 0H217Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 1161,
    d: "M579 -30Q444 -30 341 24T179 175T120 404Q120 538 185 642T383 801L381 743Q270 784 212 877T154 1083Q154 1203 209 1289T359 1423T579 1470Q703 1470 799 1423T950 1290T1005 1083Q1005 970 950 878T780 743L775 801Q908 748 974 643T1041 404Q1041 273 982 176T819 24T579 -30ZM579 111Q715 111 800 186T885 404Q885 548 801 622T579 697Q441 697 358 623T275 404Q275 262 359 187T579 111ZM579 839Q699 839 774 900T849 1083Q849 1204 774 1264T579 1325Q459 1325 385 1265T310 1083Q310 962 384 901T579 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 1241,
    d: "M614 1469Q750 1469 860 1404T1036 1226T1101 973V473Q1101 329 1036 215T859 36T603 -30Q480 -30 376 24T203 175L315 268Q361 197 437 154T603 111Q705 111 783 159T907 287T953 460V774L989 732Q927 633 825 572T600 511Q467 511 360 575T190 747T127 988Q127 1121 193 1230T370 1404T614 1469ZM614 1327Q520 1327 443 1282T321 1159T275 988Q275 894 320 817T442 695T613 649Q707 649 784 694T907 817T953 988Q953 1081 908 1158T785 1281T614 1327Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 598,
    d: "M220 160V331H391V160H220ZM221 749V920H392V749H221Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 611,
    d: "M220 -209L229 -136Q269 -139 287 -120T309 -69T311 0H220V211H391V-40Q391 -132 345 -178T220 -209ZM220 909V1080H391V909H220Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 1229,
    d: "M749 161L280 630L749 1099L843 1007L461 630L843 253L749 161Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 1500,
    d: "M240 827V953H1260V827H240ZM240 487V613H1260V487H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 1229,
    d: "M479 161L386 253L767 630L386 1007L479 1099L949 630L479 161Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 1047,
    d: "M422 393Q422 471 429 530T469 650Q499 707 543 744T635 815T726 895Q765 940 778 986T791 1083Q791 1134 779 1174T740 1243Q700 1292 642 1310T521 1328Q459 1328 406 1311T317 1257Q283 1225 268 1180T252 1085H100Q104 1164 134 1239T224 1366Q283 1420 361 1444T520 1469Q618 1469 706 1440T854 1341Q902 1290 924 1225T947 1085Q947 1002 916 929T829 799Q795 762 752 731T670 666T609 593Q583 545 581 502T578 393H422ZM423 0V196H578V0H423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 1807,
    d: "M907 -210Q747 -210 611 -155T374 0T217 235T160 529Q160 698 215 837T370 1078T609 1235T912 1290Q1101 1290 1242 1230T1476 1066T1610 833T1646 566Q1636 377 1557 281T1335 185Q1243 185 1175 228T1084 349L1132 344Q1097 273 1028 241T883 209Q792 209 724 248T617 358T578 520Q578 616 618 686T728 794T886 832Q951 832 1020 805T1127 717L1088 673V804H1194L1193 479Q1193 405 1227 359T1342 312Q1396 312 1432 342T1489 426T1512 555Q1518 707 1473 821T1345 1011T1153 1126T919 1164Q769 1164 653 1114T456 976T334 774T295 530Q296 397 343 285T475 90T671 -38T914 -84Q999 -84 1084 -62T1237 -1L1284 -113Q1197 -162 1101 -186T907 -210ZM891 337Q969 337 1018 382T1068 521Q1068 613 1021 660T894 707Q804 707 757 658T709 521Q709 432 758 385T891 337Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 1267,
    d: "M40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 1226,
    d: "M140 0V1440H696Q817 1440 907 1390T1047 1256T1097 1069Q1097 953 1035 863T869 737L867 786Q1007 746 1087 646T1167 404Q1167 279 1114 189T965 49T742 0H140ZM288 141H706Q794 141 864 172T974 262T1015 402Q1015 482 978 546T878 648T733 687H288V141ZM288 826H695Q764 826 821 857T911 944T945 1071Q945 1173 875 1237T695 1301H288V826Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 1431,
    d: "M723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q974 1470 1133 1342T1351 997L1201 958Q1155 1129 1036 1229T723 1329Q554 1329 442 1252T274 1038T215 720Q214 540 270 403T440 189T723 111Q917 111 1036 211T1201 482L1351 443Q1292 227 1133 99T723 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 1343,
    d: "M140 0V1440H577Q600 1440 655 1439T762 1431Q926 1408 1036 1309T1201 1057T1256 720Q1256 536 1201 383T1036 131T762 9Q712 3 655 2T577 0H140ZM292 141H577Q618 141 665 143T747 153Q873 175 950 255T1064 455T1100 720Q1100 865 1064 986T950 1186T747 1287Q713 1294 665 1296T577 1299H292V141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 1140,
    d: "M140 0V1440H1040V1299H287V801H920V660H287V141H1040V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 1007,
    d: "M140 0V1440H967V1293H287V793H847V647H287V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 1410,
    d: "M717 -30Q565 -30 443 23T236 174T105 410T60 720Q60 946 138 1114T364 1376T717 1469Q947 1469 1091 1362T1293 1073L1145 1037Q1098 1169 991 1248T723 1327Q554 1328 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Q878 111 979 171T1132 343T1192 608H860V734H1346Q1349 711 1349 686T1350 649Q1350 454 1280 301T1070 59T717 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 1369,
    d: "M140 0V1440H287V791H1083V1440H1229V0H1083V650H287V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 467,
    d: "M160 0V1440H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 927,
    d: "M386 -29Q242 -29 139 51T0 265L147 300Q165 221 230 167T385 112Q441 112 498 139T589 228Q611 271 614 321T618 443V1440H766V443Q766 383 765 335T755 242T719 152Q667 61 580 16T386 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 1187,
    d: "M140 0V1440H287V760L944 1440H1132L461 745L1187 0H995L287 720V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 1021,
    d: "M160 0V1440H307V141H991V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 1681,
    d: "M140 0V1440H275L841 229L1404 1440H1541V1H1401V1112L888 0H793L281 1112V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 1369,
    d: "M140 0V1440H288L1081 260V1440H1229V0H1081L288 1181V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 1447,
    d: "M723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 1208,
    d: "M140 0V1440H696Q717 1440 743 1439T797 1432Q910 1415 988 1354T1107 1199T1148 993Q1148 881 1107 788T988 634T797 555Q770 551 744 549T696 547H287V0H140ZM287 687H692Q710 687 734 689T781 696Q855 712 902 757T973 864T997 993Q997 1060 974 1122T903 1230T781 1291Q758 1296 734 1297T692 1299H287V687Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 1447,
    d: "M1271 -29L887 353L987 453L1369 71L1271 -29ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 1261,
    d: "M140 0V1440H696Q717 1440 743 1439T797 1432Q910 1415 988 1354T1107 1199T1148 993Q1148 830 1062 710T816 559L765 547H287V0H140ZM1012 0L728 586L869 640L1181 0H1012ZM287 687H692Q710 687 734 689T781 696Q855 712 902 757T973 864T997 993Q997 1060 974 1122T903 1230T781 1291Q758 1296 734 1297T692 1299H287V687Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 1233,
    d: "M640 -30Q489 -30 369 20T170 164T67 385L217 410Q253 270 369 191T646 111Q752 111 836 144T968 240T1016 387Q1016 443 996 482T943 548T871 591T795 620L430 729Q364 748 308 777T211 848T146 946T123 1074Q123 1196 187 1285T362 1422T615 1469Q759 1469 872 1418T1060 1273T1158 1049L1004 1021Q989 1115 935 1184T798 1290T614 1329Q517 1329 442 1297T322 1208T278 1080Q278 1007 318 963T418 894T534 853L816 770Q860 758 919 736T1035 672T1129 563T1166 393Q1166 293 1127 214T1016 81T849 -1T640 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 1193,
    d: "M523 0V1299H20V1440H1173V1299H670V0H523Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 1404,
    d: "M702 -30Q537 -30 411 38T212 230T140 520V1439L288 1440V539Q288 427 326 346T425 212T560 134T702 109Q772 109 845 134T979 211T1078 345T1116 539V1440H1264V520Q1264 354 1192 231T994 39T702 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 1207,
    d: "M506 0L10 1440H163L602 167L1044 1440H1197L701 0H506Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 1871,
    d: "M449 0L33 1440H186L523 251L858 1439L1012 1440L1349 251L1684 1440H1838L1423 0H1275L935 1181L597 0H449Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 1212,
    d: "M20 0L519 729L33 1440H211L606 852L1001 1440H1180L694 729L1192 0H1014L606 605L199 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 1112,
    d: "M483 0V603L0 1440H170L557 771L942 1440H1112L631 603V0H483Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 1228,
    d: "M100 0V31L887 1299H120V1440H1128V1406L345 140H1121V0H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 814,
    d: "M280 -436V1776H654V1640H416V-300H654V-436H280Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 775,
    d: "M271 1440L655 0H504L120 1440H271Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 814,
    d: "M534 -436H160V-300H398V1640H160V1776H534V-436Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 1339,
    d: "M211 1002L679 1472L1150 1003L1058 910L679 1291L303 909L211 1002Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 1320,
    d: "M0 -213V-87H1320V-213H0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 979,
    d: "M463 1610L343 1920H469L589 1610H463Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 1111,
    d: "M449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 1184,
    d: "M625 -30Q476 -30 373 45T217 250T164 541Q164 705 217 833T375 1036T631 1110Q779 1110 885 1035T1047 831T1104 541Q1104 379 1047 250T883 46T625 -30ZM139 0V1440H287V813H271V0H139ZM610 107Q723 107 798 164T910 319T948 541Q948 663 911 761T799 916T607 973Q494 973 420 918T308 766T271 541Q271 416 308 318T420 163T610 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 1107,
    d: "M588 -30Q425 -30 312 43T141 244T80 540Q82 710 142 838T315 1038T589 1110Q753 1110 874 1030T1041 811L897 765Q859 862 777 915T588 969Q469 969 391 915T275 763T236 540Q238 346 326 229T588 111Q698 111 775 161T893 309L1041 265Q981 121 865 46T588 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 1185,
    d: "M559 -30Q408 -30 301 45T137 250T80 541Q80 702 136 831T299 1035T553 1110Q705 1110 809 1036T966 834T1020 541Q1020 380 967 251T811 46T559 -30ZM574 107Q689 107 764 163T876 317T913 541Q913 668 876 765T765 918T577 973Q461 973 385 916T273 761T236 541Q236 418 273 320T386 164T574 107ZM913 0V813H897V1440H1045V0H913Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 1169,
    d: "M597 -30Q439 -30 324 40T144 237T80 535Q80 712 143 841T320 1040T591 1110Q751 1110 864 1037T1035 826T1088 499H938V551Q934 761 848 868T595 975Q421 975 329 862T236 540Q236 336 328 224T591 111Q707 111 793 164T930 319L1067 266Q1003 125 879 48T597 -30ZM184 499V622H1009V499H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 709,
    d: "M247 0V1160Q247 1202 251 1243T270 1321T314 1391Q347 1427 386 1443T467 1465T551 1470H689V1346H561Q477 1346 436 1305T394 1176V0H247ZM60 954V1080H689V954H60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 1184,
    d: "M569 -510Q486 -510 406 -486T257 -409T143 -272L276 -198Q321 -288 402 -327T569 -367Q686 -367 758 -324T864 -195T896 17V305H913V1080H1044V15Q1044 -31 1042 -73T1032 -157Q1013 -278 954 -356T798 -472T569 -510ZM559 -30Q408 -30 301 45T137 250T80 541Q80 702 136 831T299 1035T553 1110Q705 1110 809 1036T966 834T1020 541Q1020 380 967 251T811 46T559 -30ZM574 107Q689 107 764 163T876 317T913 541Q913 668 876 765T765 918T577 973Q461 973 385 916T273 761T236 541Q236 418 273 320T386 164T574 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 1188,
    d: "M920 0V551Q920 641 903 716T849 848T752 936T607 967Q529 967 470 940T370 863T308 740T287 576L183 599Q183 765 241 878T401 1049T635 1107Q732 1107 804 1077T927 996T1009 880T1054 741T1068 594V0H920ZM139 0V1440H272V627H287V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 467,
    d: "M160 1285V1450H307V1285H160ZM160 0V1080H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 501,
    d: "M-20 -480V-338H41Q114 -338 157 -301T201 -175V1080H347V-212Q347 -347 283 -413T85 -480H-20ZM201 1285V1450H347V1285H201Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 992,
    d: "M139 0L140 1440H288V560L770 1080H966L460 540L1032 0H818L288 520V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 467,
    d: "M160 0V1470H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 1696,
    d: "M1428 0L1429 709Q1429 834 1360 905T1183 977Q1122 977 1064 949T969 859T931 697L844 722Q841 838 889 925T1023 1060T1217 1109Q1380 1109 1478 1009T1576 737L1575 0H1428ZM139 0V1080H271V814H287V0H139ZM785 0L786 699Q786 828 718 902T537 977Q425 977 356 901T287 697L199 745Q199 849 248 931T382 1061T575 1109Q678 1109 758 1065T885 937T931 733L930 0H785Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 1188,
    d: "M920 0V551Q920 641 903 716T849 848T752 936T607 967Q529 967 470 940T370 863T308 740T287 576L183 599Q183 765 241 878T401 1049T635 1107Q732 1107 804 1077T927 996T1009 880T1054 741T1068 594V0H920ZM139 0V1080H272V814H287V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 1183,
    d: "M591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 1184,
    d: "M625 -30Q476 -30 373 45T217 250T164 541Q164 705 217 833T375 1036T631 1110Q779 1110 885 1035T1047 831T1104 541Q1104 379 1047 250T883 46T625 -30ZM139 -480V1080H271V267H287V-480H139ZM610 107Q723 107 798 164T910 319T948 541Q948 663 911 761T799 916T607 973Q494 973 420 918T308 766T271 541Q271 416 308 318T420 163T610 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 1185,
    d: "M559 -30Q408 -30 301 45T137 250T80 541Q80 702 136 831T299 1035T553 1110Q705 1110 809 1036T966 834T1020 541Q1020 380 967 251T811 46T559 -30ZM574 107Q689 107 764 163T876 317T913 541Q913 668 876 765T765 918T577 973Q461 973 385 916T273 761T236 541Q236 418 273 320T386 164T574 107ZM897 -480V267H913V1080H1045V-480H897Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 721,
    d: "M140 0V1080H272V820L246 854Q264 902 293 942T356 1009Q398 1046 454 1065T567 1088T671 1080V942Q612 957 542 949T413 893Q359 851 332 793T296 669T287 539V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 1050,
    d: "M543 -29Q353 -29 231 53T80 281L230 306Q254 214 339 160T551 105Q674 105 745 156T816 297Q816 347 794 378T702 437T496 501Q349 541 266 581T148 673T113 802Q113 894 165 963T309 1071T523 1110Q645 1110 741 1071T897 960T967 795L817 768Q802 863 723 918T521 976Q406 979 334 933T262 809Q262 766 288 736T382 678T578 619Q727 581 812 539T933 440T969 299Q969 146 856 59T543 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 801,
    d: "M728 0Q637 -19 549 -15T391 23T285 129Q256 189 254 250T251 391V1380H397V397Q397 329 398 284T419 203Q455 136 533 123T728 129V0ZM20 954V1080H728V954H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 1188,
    d: "M553 -27Q456 -27 384 3T261 84T179 200T134 339T120 486V1080H268V529Q268 440 285 364T339 232T436 144T581 113Q659 113 718 140T818 217T880 340T901 504L1005 481Q1005 315 947 202T787 31T553 -27ZM916 0V266H901V1080H1048V0H916Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 1016,
    d: "M432 0L40 1080H189L508 192L825 1080H976L584 0H432Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 1535,
    d: "M370 0L40 1081L187 1080L443 241L700 1080H834L1091 241L1349 1080H1495L1165 0H1037L767 860L498 0H370Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 1054,
    d: "M20 0L442 546L29 1080H205L528 659L848 1080H1024L611 546L1034 0H857L528 433L197 0H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 1055,
    d: "M294 -480L503 87L506 -81L33 1080H189L577 109H513L871 1080H1021L441 -480H294Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 1059,
    d: "M40 0V31L737 943H92V1080H979V1046L283 137H941V0H40Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 839,
    d: "M633 -436Q529 -436 462 -369T395 -199V453Q395 484 377 511L292 630Q280 648 280 670T292 710L377 829Q395 858 395 887V1538Q395 1642 462 1709T633 1776H752V1635H639Q597 1635 567 1605T536 1531V887Q536 810 491 747L436 670L491 593Q536 530 536 453V-193Q536 -235 566 -265T639 -295H752V-436H633Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 507,
    d: "M180 0V1440H327V0H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 839,
    d: "M206 -436H87V-295H199Q243 -295 273 -265T303 -193V453Q303 530 347 593L403 670L347 747Q303 810 303 887V1531Q303 1575 273 1605T199 1635H87V1776H206Q310 1776 377 1709T444 1538V887Q444 858 462 829L547 710Q560 692 560 670T547 630L462 511Q444 484 444 453V-199Q444 -302 377 -369T206 -436Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 1324,
    d: "M873 466Q814 466 758 490T649 545T549 601T459 626Q404 626 389 583T389 489H243Q222 574 240 642T312 751T448 792Q509 792 566 768T675 712T775 656T865 632Q914 632 933 674T935 772H1081Q1102 689 1084 620T1012 508T873 466Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 400
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 627,
    d: "M240 1080H387V915H240V1080ZM240 720H387V-360H240V720Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 1107,
    d: "M531 -59V123Q385 136 286 211T134 410T80 690Q82 850 134 972T287 1169T531 1256V1440H657V1255Q795 1240 897 1163T1041 961L897 915Q859 1012 777 1065T588 1119Q469 1119 391 1065T275 913T236 690Q238 496 326 379T588 261Q698 261 775 311T893 459L1041 415Q986 287 889 214T657 125V-59H531Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 1142,
    d: "M67 0V141H169Q227 141 269 183T311 283V1094Q311 1204 360 1289T495 1422T689 1470Q783 1470 855 1429T982 1308T1075 1115L941 1071Q900 1200 840 1264T687 1329Q584 1329 522 1264T459 1089V141H1022V0H67ZM67 660V801H823V660H67Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 1283,
    d: "M641 196Q533 196 438 237T271 350T158 518T117 722Q117 830 158 925T271 1092T438 1205T641 1246Q750 1246 845 1205T1012 1092T1126 925T1167 722Q1167 613 1126 518T1013 351T845 237T641 196ZM160 140L60 240L273 453L373 353L160 140ZM274 987L60 1201L160 1300L373 1087L274 987ZM1123 140L910 353L1010 453L1223 240L1123 140ZM641 328Q750 328 839 382T982 525T1035 720Q1035 829 981 918T837 1060T641 1113Q533 1113 444 1060T302 918T249 720Q249 614 302 525T444 382T641 328ZM1009 987L910 1087L1123 1300L1223 1201L1009 987Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 1112,
    d: "M177 517V643H937V517H177ZM177 225V351H937V225H177ZM483 0V603L0 1440H170L557 771L942 1440H1112L631 603V0H483Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 507,
    d: "M180 701V1440H327V701H180ZM180 -312V427H327V-312H180Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 1050,
    d: "M548 -309Q449 -309 358 -277T201 -177T113 1L263 26Q282 -46 329 -90T437 -154T555 -175Q618 -175 673 -153T762 -89T796 17Q796 78 761 111T655 168T476 221Q360 252 274 287T141 376T93 515Q93 613 150 676T296 767T477 785L481 736Q377 709 310 658T242 531Q242 473 283 440T395 385T558 339Q675 309 763 274T900 180T949 21Q949 -87 896 -160T751 -271T548 -309ZM613 246L611 299Q664 302 714 327T796 396T829 504Q829 564 795 598T689 655T509 708Q394 739 308 774T175 863T127 1009Q127 1113 184 1181T329 1283T511 1317Q614 1317 703 1278T850 1169T920 1002L770 975Q756 1052 714 1097T614 1163T501 1183Q440 1183 389 1163T306 1106T275 1018Q275 960 317 927T430 871T591 826Q708 795 796 760T933 667T982 510Q982 408 933 341T800 249T613 246Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 1021,
    d: "M621 1651V1811H781V1651H621ZM240 1651V1811H400V1651H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 1607,
    d: "M803 -53Q650 -53 515 4T278 164T118 401T60 690Q60 844 118 979T278 1216T515 1375T803 1433Q958 1433 1092 1376T1329 1216T1489 979T1547 690Q1547 536 1489 401T1329 164T1093 5T803 -53ZM812 269Q721 269 649 300T523 399Q471 465 452 541T432 693Q433 771 453 846T523 983Q577 1050 650 1082T818 1114Q872 1114 920 1103T1015 1063Q1063 1033 1100 988T1153 884L1030 847Q1018 878 996 907T945 957Q917 977 883 986T813 996Q755 996 707 973T625 907Q591 863 578 807T565 694Q565 633 579 576T625 477Q657 433 705 410T813 387Q891 387 947 425Q976 446 995 472T1027 530L1153 496Q1131 439 1097 397T1026 329Q981 299 930 284T812 269ZM803 90Q928 90 1036 136T1226 265T1355 457T1402 691Q1402 816 1356 924T1227 1114T1036 1243T803 1290Q679 1290 570 1244T378 1115T249 924T202 691Q202 567 248 458T377 266T569 137T803 90Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 630,
    d: "M263 540Q173 540 127 588T80 702Q80 763 113 802T208 862Q260 878 334 888T482 909L446 872Q450 944 423 978T325 1013Q282 1013 247 994T197 929L100 958Q120 1028 176 1069T325 1110Q398 1110 452 1086T530 1007Q543 981 546 951T550 888V555H457V678L473 658Q439 598 388 569T263 540ZM281 626Q348 626 386 659T435 732Q444 757 444 789T445 836L481 822Q407 811 352 803T258 783Q226 773 205 754T184 703Q184 671 207 649T281 626Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 1071,
    d: "M849 106L503 541L849 975L938 906L647 541L938 175L849 106ZM506 106L160 541L506 975L595 906L303 541L595 175L506 106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 1200,
    d: "M954 390V637H120V763H1080V390H954Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 840,
    d: "M120 567V693H720V567H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 1250,
    d: "M625 575Q525 575 437 612T282 717T178 872T140 1061Q140 1161 177 1248T282 1402T437 1507T625 1545Q726 1545 813 1507T968 1403T1072 1249T1110 1061Q1110 960 1073 872T968 717T814 613T625 575ZM626 689Q728 689 812 739T946 874T996 1061Q996 1163 946 1247T812 1381T626 1431Q523 1431 439 1381T305 1247T255 1061Q255 958 305 874T439 740T626 689ZM462 831V1296H665Q730 1296 774 1253T819 1145Q819 1104 797 1067T733 1009L821 831H733L653 994H540V831H462ZM540 1067H665Q695 1067 717 1089T739 1145Q739 1180 717 1201T665 1222H540V1067Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 981,
    d: "M240 1680V1805H741V1680H240Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 900,
    d: "M420 750Q321 750 239 798T109 928T60 1110Q60 1208 110 1290T242 1421T420 1470Q519 1470 600 1422T731 1292T780 1110Q780 1010 731 929T601 799T420 750ZM420 883Q482 883 533 914T616 996T647 1110Q647 1172 616 1223T534 1306T420 1337Q358 1337 307 1306T224 1224T193 1110Q193 1048 224 997T306 914T420 883Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 1200,
    d: "M537 440V697H120V823H537V1080H663V823H1080V697H663V440H537ZM120 157V283H1080V157H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 800,
    d: "M100 540L101 640L501 1001Q551 1046 568 1086T585 1168Q585 1247 534 1301T404 1355Q350 1355 308 1329T242 1261T219 1170H104Q104 1255 143 1320T250 1423T405 1460Q489 1460 555 1422T661 1317T700 1167Q700 1108 685 1066T639 987T562 909L214 594L193 647H700V540H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 779,
    d: "M365 519Q265 519 187 574T80 724L187 755Q208 691 256 659T365 627Q448 628 496 680T545 815Q545 898 495 950T363 1003Q340 1003 316 997T269 981L215 1068L567 1388L588 1334H116V1440H649V1333L346 1045L343 1097Q438 1107 509 1073T620 971T659 815Q659 728 621 662T516 557T365 519Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 979,
    d: "M517 1610H391L510 1920H636L517 1610Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 1207,
    d: "M139 -480V1080H287V529Q287 440 304 364T359 232T456 144T601 113Q678 113 738 140T838 217T899 340T920 504V1080H1067V0H935V153Q876 63 782 18T572 -27Q473 -27 397 9T271 112V-480H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 1269,
    d: "M688 -282V547H599Q583 547 556 548T497 555Q386 572 308 633T188 788T147 993Q147 1105 187 1198T306 1353T497 1432Q529 1437 555 1438T599 1440H835V-282H688ZM976 -282V1440H1123V-282H976Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 453,
    d: "M229 523Q184 523 152 553T120 630Q120 676 152 706T229 737Q272 737 302 707T333 630Q333 584 303 554T229 523Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 794,
    d: "M367 -480Q331 -480 300 -471T240 -449L278 -347Q324 -365 355 -365Q394 -365 415 -341T437 -287Q437 -241 396 -221T304 -185L378 21H487L436 -119Q490 -143 523 -184T557 -291Q557 -372 501 -426T367 -480Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 642,
    d: "M290 540V1317L120 1214V1338L290 1440H402V540H290Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 690,
    d: "M344 540Q223 540 152 620T80 826Q80 953 153 1031T344 1110Q466 1110 538 1031T610 826Q610 699 538 620T344 540ZM344 639Q422 639 460 691T498 826Q498 910 460 961T344 1012Q265 1012 228 961T191 826Q191 741 229 690T344 639Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 1071,
    d: "M222 106L133 175L425 541L133 906L222 975L568 541L222 106ZM565 106L477 175L768 541L477 906L565 975L911 541L565 106Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 1947,
    d: "M290 540V1317L120 1214V1338L290 1440H402V540H290ZM1501 0V165H1087V272L1384 900H1511L1213 272H1501V525H1613V272H1707V165H1613V0H1501ZM381 0L280 78L1331 1445L1430 1367L381 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 1868,
    d: "M290 540V1317L120 1214V1338L290 1440H402V540H290ZM1168 0L1170 100L1569 461Q1619 506 1636 546T1654 628Q1654 707 1602 761T1472 815Q1419 815 1377 789T1310 721T1287 630H1172Q1172 715 1211 780T1319 883T1474 920Q1558 920 1624 882T1729 777T1768 627Q1768 568 1753 526T1707 447T1630 369L1282 54L1262 107H1768V0H1168ZM381 0L280 78L1331 1445L1430 1367L381 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 1959,
    d: "M365 519Q265 519 187 574T80 724L187 755Q208 691 256 659T365 627Q448 628 496 680T545 815Q545 898 495 950T363 1003Q340 1003 316 997T269 981L215 1068L567 1388L588 1334H116V1440H649V1333L346 1045L343 1097Q438 1107 509 1073T620 971T659 815Q659 728 621 662T516 557T365 519ZM1633 0V165H1219V272L1516 900H1643L1345 272H1633V525H1745V272H1839V165H1745V0H1633ZM518 0L417 78L1468 1445L1567 1367L518 0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 1047,
    d: "M625 687Q625 609 618 550T578 430Q548 373 505 336T413 265T321 185Q283 141 270 95T256 -3Q256 -53 269 -93T307 -163Q347 -211 405 -229T526 -248Q589 -248 643 -231T731 -177Q766 -144 781 -99T795 -5H947Q943 -84 913 -159T823 -286Q764 -339 686 -364T527 -389Q429 -389 341 -359T193 -261Q146 -209 123 -144T100 -5Q100 78 131 151T218 281Q252 318 295 350T378 415T439 487Q466 535 467 578T469 687H625ZM625 1080V884H469V1080H625Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 1267,
    d: "M557 1610L437 1920H563L683 1610H557ZM1227 0H1074L607 1358H664L193 0H40L536 1440H731L1227 0ZM1006 349H262V487H1006V349Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 1267,
    d: "M711 1610H585L704 1920H830L711 1610ZM40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 1267,
    d: "M336 1610L565 1880H701L931 1610H781L633 1783L486 1610H336ZM40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 1267,
    d: "M784 1662Q742 1662 702 1679T625 1718T554 1758T490 1775Q451 1775 441 1745T441 1679H337Q314 1768 354 1830T483 1893Q526 1893 566 1876T643 1837T714 1797T778 1780Q813 1780 826 1810T827 1879H931Q954 1791 914 1727T784 1662ZM40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 1267,
    d: "M745 1651V1811H905V1651H745ZM364 1651V1811H524V1651H364ZM40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 1267,
    d: "M635 1557Q575 1557 525 1586T445 1665T415 1776Q415 1836 445 1886T525 1965T635 1995Q696 1995 745 1966T824 1886T854 1776Q854 1715 825 1666T746 1587T635 1557ZM635 1666Q681 1666 713 1698T745 1776Q745 1822 713 1854T635 1886Q590 1886 558 1854T525 1776Q525 1731 557 1699T635 1666ZM40 0L536 1440H731L1227 0H1074L603 1358H661L193 0H40ZM261 349V487H1005V349H261Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 1837,
    d: "M40 0L536 1440H893V1299H578L659 1356L193 0H40ZM261 349V487H939V349H261ZM837 0V1440H1737V1299H983V801H1617V660H983V141H1737V0H837Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 1431,
    d: "M709 -480Q673 -480 641 -471T581 -449L619 -347Q666 -365 697 -365Q736 -365 757 -341T778 -287Q778 -241 737 -221T645 -185L719 21H828L777 -119Q831 -143 864 -184T898 -291Q898 -372 842 -426T709 -480ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q974 1470 1133 1342T1351 997L1201 958Q1155 1129 1036 1229T723 1329Q554 1329 442 1252T274 1038T215 720Q214 540 270 403T440 189T723 111Q917 111 1036 211T1201 482L1351 443Q1292 227 1133 99T723 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 1140,
    d: "M558 1610L439 1920H565L684 1610H558ZM140 0V1440H1040V1299H287V801H920V660H287V141H1040V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 1140,
    d: "M677 1610H551L670 1920H796L677 1610ZM140 0V1440H1040V1299H287V801H920V660H287V141H1040V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 1140,
    d: "M281 1610L511 1880H647L876 1610H726L579 1783L431 1610H281ZM140 0V1440H1040V1299H287V801H920V660H287V141H1040V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 1140,
    d: "M680 1651V1811H840V1651H680ZM299 1651V1811H459V1651H299ZM140 0V1440H1040V1299H287V801H920V660H287V141H1040V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 467,
    d: "M168 1610L48 1920H174L294 1610H168ZM160 0V1440H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 467,
    d: "M299 1610H173L292 1920H418L299 1610ZM160 0V1440H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 467,
    d: "M-65 1610L164 1880H300L529 1610H379L232 1783L85 1610H-65ZM160 0V1440H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 467,
    d: "M344 1651V1811H504V1651H344ZM-37 1651V1811H123V1651H-37ZM160 0V1440H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 1331,
    d: "M20 657V783H650V657H20ZM128 0V1440H565Q588 1440 643 1439T750 1431Q914 1408 1024 1309T1189 1057T1244 720Q1244 536 1189 383T1024 131T750 9Q700 3 643 2T565 0H128ZM280 141H565Q606 141 653 143T735 153Q861 175 938 255T1052 455T1088 720Q1088 865 1052 986T938 1186T735 1287Q701 1294 653 1296T565 1299H280V141Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 1369,
    d: "M861 1612Q818 1612 779 1629T702 1668T630 1708T567 1725Q528 1725 517 1695T517 1629H413Q391 1718 431 1780T559 1843Q602 1843 642 1826T720 1787T791 1747T855 1730Q890 1730 903 1760T904 1829H1008Q1031 1741 991 1677T861 1612ZM140 0V1440H288L1081 260V1440H1229V0H1081L288 1181V0H140Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 1447,
    d: "M656 1610L537 1920H663L782 1610H656ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 1447,
    d: "M804 1610H678L797 1920H923L804 1610ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 1447,
    d: "M425 1610L654 1880H790L1019 1610H869L722 1783L575 1610H425ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 1447,
    d: "M723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111ZM888 1612Q846 1612 806 1629T729 1668T658 1708T594 1725Q555 1725 545 1695T545 1629H441Q418 1718 458 1780T587 1843Q630 1843 670 1826T747 1787T818 1747T882 1730Q917 1730 930 1760T931 1829H1035Q1058 1741 1018 1677T888 1612Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 1447,
    d: "M834 1651V1811H994V1651H834ZM453 1651V1811H613V1651H453ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 975,
    d: "M767 352L488 631L209 352L120 442L399 720L120 998L209 1087L488 809L766 1087L855 998L576 720L855 442L767 352Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 1447,
    d: "M143 -26L38 69L224 272L250 298L1116 1239L1133 1259L1318 1461L1423 1367L1223 1147L1204 1131L339 189L317 162L143 -26ZM723 -30Q508 -30 360 65T136 330T60 720Q60 941 136 1110T360 1374T723 1470Q939 1470 1086 1375T1310 1110T1387 720Q1387 499 1311 330T1087 66T723 -30ZM723 111Q892 111 1005 188T1174 402T1231 720Q1231 900 1175 1037T1005 1251T723 1329Q554 1329 442 1252T274 1038T216 720Q215 540 271 404T441 190T723 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 1404,
    d: "M660 1610L541 1920H667L786 1610H660ZM702 -30Q537 -30 411 38T212 230T140 520V1439L288 1440V539Q288 427 326 346T425 212T560 134T702 109Q772 109 845 134T979 211T1078 345T1116 539V1440H1264V520Q1264 354 1192 231T994 39T702 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 1404,
    d: "M749 1610H623L742 1920H868L749 1610ZM702 -30Q537 -30 411 38T212 230T140 520V1439L288 1440V539Q288 427 326 346T425 212T560 134T702 109Q772 109 845 134T979 211T1078 345T1116 539V1440H1264V520Q1264 354 1192 231T994 39T702 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 1404,
    d: "M403 1610L633 1880H769L998 1610H848L701 1783L553 1610H403ZM702 -30Q537 -30 411 38T212 230T140 520V1439L288 1440V539Q288 427 326 346T425 212T560 134T702 109Q772 109 845 134T979 211T1078 345T1116 539V1440H1264V520Q1264 354 1192 231T994 39T702 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 1404,
    d: "M813 1651V1811H973V1651H813ZM431 1651V1811H591V1651H431ZM702 -30Q537 -30 411 38T212 230T140 520V1439L288 1440V539Q288 427 326 346T425 212T560 134T702 109Q772 109 845 134T979 211T1078 345T1116 539V1440H1264V520Q1264 354 1192 231T994 39T702 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 1112,
    d: "M600 1610H474L593 1920H719L600 1610ZM483 0V603L0 1440H170L557 771L942 1440H1112L631 603V0H483Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 1189,
    d: "M140 0V1440H288V1167H681Q758 1167 832 1139Q882 1122 927 1092T1007 1022Q1065 962 1097 883T1129 720Q1130 641 1101 567T1021 433Q962 360 871 317T681 274H288V0H140ZM288 415H680Q743 415 804 445T908 527Q941 568 960 617T977 720Q976 780 954 836T889 934Q850 975 794 1000T680 1025H288V415Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 1197,
    d: "M625 -29Q573 -29 528 -23T441 0V145Q482 131 522 124T611 117Q752 117 839 193T927 412Q927 547 822 622T546 700V835Q615 842 673 871T765 952T800 1084Q800 1200 730 1264T547 1329Q469 1329 405 1295T314 1185Q302 1151 297 1109T292 1023V0H139V1063Q139 1113 145 1156T165 1233Q194 1313 248 1365T377 1444T545 1470Q664 1470 755 1424T899 1292T951 1085Q951 983 907 903T778 789Q826 780 878 752T975 675T1048 561T1077 411Q1077 211 961 91T625 -29Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 1111,
    d: "M509 1250L389 1560H515L635 1250H509ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 1111,
    d: "M630 1250H504L624 1560H750L630 1250ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 1111,
    d: "M273 1250L503 1520H639L868 1250H718L571 1423L423 1250H273ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 1111,
    d: "M731 1252Q689 1252 649 1269T572 1308T501 1348T437 1365Q399 1365 388 1335T388 1269H284Q262 1358 302 1420T430 1483Q473 1483 513 1466T590 1427T662 1387T725 1370Q761 1370 774 1400T775 1469H879Q901 1381 861 1317T731 1252ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 1111,
    d: "M689 1291V1451H849V1291H689ZM308 1291V1451H468V1291H308ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 1111,
    d: "M570 1197Q510 1197 460 1226T381 1305T351 1416Q351 1476 380 1526T460 1605T570 1635Q631 1635 680 1606T759 1526T789 1416Q789 1355 760 1306T681 1227T570 1197ZM570 1306Q617 1306 648 1338T680 1416Q680 1462 649 1494T570 1526Q525 1526 493 1494T460 1416Q460 1371 492 1339T570 1306ZM449 -30Q327 -30 245 14T121 131T80 290Q80 378 115 440T212 543T355 604Q437 624 536 639T731 666T899 689L847 657Q850 817 785 894T559 971Q448 971 372 921T264 763L121 805Q158 950 270 1030T561 1110Q709 1110 812 1055T959 894Q979 847 985 789T991 671V0H860V271L898 255Q843 116 727 43T449 -30ZM466 97Q569 97 646 134T770 235T831 381Q843 433 844 495T845 589L901 560Q826 550 739 540T567 517T414 486Q368 473 325 450T255 387T227 290Q227 243 250 199T326 126T466 97Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 1884,
    d: "M1339 -30Q1184 -30 1075 43T908 244T850 537Q850 708 908 837T1075 1038T1337 1110Q1495 1110 1600 1033T1756 818T1803 499H1660V551Q1656 748 1581 861T1334 975Q1218 975 1143 920T1033 766T997 540Q997 346 1082 229T1334 111Q1439 111 1522 162T1652 319L1782 266Q1742 171 1676 105T1523 5T1339 -30ZM466 97Q582 97 672 149T801 283Q825 330 834 385T845 485T846 551L881 513L572 503Q528 502 469 496T355 471T264 409T227 293Q227 200 291 149T466 97ZM459 -30Q280 -30 180 57T80 291Q80 381 114 440T204 533T324 585T449 608T553 617L867 627L845 602Q852 725 824 807T730 930T563 971Q457 971 375 926T261 773L121 816Q147 909 210 974T364 1075T564 1110Q732 1110 834 1038T971 836Q985 791 988 747T991 665L928 271Q884 157 811 91T646 -2T459 -30ZM947 499V625H1728V499H947Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 1107,
    d: "M539 -480Q503 -480 472 -471T412 -449L450 -347Q496 -365 527 -365Q566 -365 587 -341T609 -287Q609 -241 568 -221T476 -185L550 21H659L608 -119Q662 -143 695 -184T729 -291Q729 -372 673 -426T539 -480ZM588 -30Q425 -30 312 43T141 244T80 540Q82 710 142 838T315 1038T589 1110Q753 1110 874 1030T1041 811L897 765Q859 862 777 915T588 969Q469 969 391 915T275 763T236 540Q238 346 326 229T588 111Q698 111 775 161T893 309L1041 265Q981 121 865 46T588 -30Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 1169,
    d: "M542 1250L423 1560H549L668 1250H542ZM597 -30Q439 -30 324 40T144 237T80 535Q80 712 143 841T320 1040T591 1110Q751 1110 864 1037T1035 826T1088 499H938V551Q934 761 848 868T595 975Q421 975 329 862T236 540Q236 336 328 224T591 111Q707 111 793 164T930 319L1067 266Q1003 125 879 48T597 -30ZM184 499V622H1009V499H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 1169,
    d: "M676 1250H550L669 1560H795L676 1250ZM597 -30Q439 -30 324 40T144 237T80 535Q80 712 143 841T320 1040T591 1110Q751 1110 864 1037T1035 826T1088 499H938V551Q934 761 848 868T595 975Q421 975 329 862T236 540Q236 336 328 224T591 111Q707 111 793 164T930 319L1067 266Q1003 125 879 48T597 -30ZM184 499V622H1009V499H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 1169,
    d: "M293 1250L522 1520H658L887 1250H737L590 1423L443 1250H293ZM597 -30Q439 -30 324 40T144 237T80 535Q80 712 143 841T320 1040T591 1110Q751 1110 864 1037T1035 826T1088 499H938V551Q934 761 848 868T595 975Q421 975 329 862T236 540Q236 336 328 224T591 111Q707 111 793 164T930 319L1067 266Q1003 125 879 48T597 -30ZM184 499V622H1009V499H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 1169,
    d: "M702 1291V1451H862V1291H702ZM321 1291V1451H481V1291H321ZM597 -30Q439 -30 324 40T144 237T80 535Q80 712 143 841T320 1040T591 1110Q751 1110 864 1037T1035 826T1088 499H938V551Q934 761 848 868T595 975Q421 975 329 862T236 540Q236 336 328 224T591 111Q707 111 793 164T930 319L1067 266Q1003 125 879 48T597 -30ZM184 499V622H1009V499H184Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 467,
    d: "M168 1250L48 1560H174L294 1250H168ZM160 0V1080H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 467,
    d: "M299 1250H173L292 1560H418L299 1250ZM160 0V1080H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 467,
    d: "M-59 1250L171 1520H307L536 1250H386L239 1423L91 1250H-59ZM160 0V1080H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 467,
    d: "M344 1291V1451H504V1291H344ZM-37 1291V1451H123V1291H-37ZM160 0V1080H307V0H160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 1165,
    d: "M583 -30Q428 -31 316 35T143 222T80 503Q81 665 142 785T316 972T583 1037Q683 1039 775 1002T935 889Q919 1024 854 1126T684 1290T441 1361L461 1484Q630 1476 756 1403T957 1197Q1007 1118 1035 1026T1074 809T1085 507Q1085 344 1024 223T851 35T583 -30ZM583 106Q754 106 844 213T934 505Q934 691 842 797T583 901Q412 903 322 796T231 504Q231 316 322 211T583 106ZM617 1125L524 1203L819 1565L913 1486L617 1125Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 1188,
    d: "M745 1252Q702 1252 663 1269T586 1308T514 1348T451 1365Q412 1365 401 1335T401 1269H297Q275 1358 315 1420T443 1483Q486 1483 526 1466T604 1427T675 1387T739 1370Q774 1370 787 1400T788 1469H892Q915 1381 875 1317T745 1252ZM920 0V551Q920 641 903 716T849 848T752 936T607 967Q529 967 470 940T370 863T308 740T287 576L183 599Q183 765 241 878T401 1049T635 1107Q732 1107 804 1077T927 996T1009 880T1054 741T1068 594V0H920ZM139 0V1080H272V814H287V0H139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 1183,
    d: "M520 1250L400 1560H526L646 1250H520ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 1183,
    d: "M654 1250H528L647 1560H773L654 1250ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 1183,
    d: "M293 1250L523 1520H659L888 1250H738L591 1423L443 1250H293ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 1183,
    d: "M743 1252Q700 1252 661 1269T584 1308T512 1348T449 1365Q410 1365 399 1335T399 1269H295Q273 1358 313 1420T441 1483Q484 1483 524 1466T602 1427T673 1387T737 1370Q772 1370 785 1400T786 1469H890Q913 1381 873 1317T743 1252ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 1183,
    d: "M703 1291V1451H863V1291H703ZM321 1291V1451H481V1291H321ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 1080,
    d: "M120 657V783H960V657H120ZM488 902V1073H659V902H488ZM488 418V589H659V418H488Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 1183,
    d: "M140 -10L40 90L210 260L252 288L873 907L897 945L1043 1090L1143 991L979 828L942 805L333 196L302 152L140 -10ZM591 -30Q430 -30 316 43T141 245T80 541Q80 711 142 839T318 1038T591 1110Q753 1110 867 1038T1042 837T1103 541Q1103 371 1042 243T866 42T591 -30ZM591 111Q771 111 859 230T947 541Q947 737 859 853T591 969Q470 969 392 915T275 764T236 541Q236 346 326 229T591 111Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 1188,
    d: "M539 1250L419 1560H545L665 1250H539ZM553 -27Q456 -27 384 3T261 84T179 200T134 339T120 486V1080H268V529Q268 440 285 364T339 232T436 144T581 113Q659 113 718 140T818 217T880 340T901 504L1005 481Q1005 315 947 202T787 31T553 -27ZM916 0V266H901V1080H1048V0H916Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 1188,
    d: "M641 1250H515L634 1560H760L641 1250ZM553 -27Q456 -27 384 3T261 84T179 200T134 339T120 486V1080H268V529Q268 440 285 364T339 232T436 144T581 113Q659 113 718 140T818 217T880 340T901 504L1005 481Q1005 315 947 202T787 31T553 -27ZM916 0V266H901V1080H1048V0H916Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 1188,
    d: "M285 1250L514 1520H650L879 1250H729L582 1423L435 1250H285ZM553 -27Q456 -27 384 3T261 84T179 200T134 339T120 486V1080H268V529Q268 440 285 364T339 232T436 144T581 113Q659 113 718 140T818 217T880 340T901 504L1005 481Q1005 315 947 202T787 31T553 -27ZM916 0V266H901V1080H1048V0H916Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 1188,
    d: "M694 1291V1451H854V1291H694ZM313 1291V1451H473V1291H313ZM553 -27Q456 -27 384 3T261 84T179 200T134 339T120 486V1080H268V529Q268 440 285 364T339 232T436 144T581 113Q659 113 718 140T818 217T880 340T901 504L1005 481Q1005 315 947 202T787 31T553 -27ZM916 0V266H901V1080H1048V0H916Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 1055,
    d: "M590 1250H464L583 1560H709L590 1250ZM294 -480L503 87L506 -81L33 1080H189L577 109H513L871 1080H1021L441 -480H294Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 1184,
    d: "M140 809V1440H287V809H140ZM625 -30Q476 -30 373 45T217 250T164 541Q164 705 217 833T375 1036T631 1110Q779 1110 885 1035T1047 831T1104 541Q1104 379 1047 250T883 46T625 -30ZM139 -480V1080H271V267H287V-480H139ZM610 107Q723 107 798 164T910 319T948 541Q948 663 911 761T799 916T607 973Q494 973 420 918T308 766T271 541Q271 416 308 318T420 163T610 107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 1055,
    d: "M648 1291V1451H808V1291H648ZM267 1291V1451H427V1291H267ZM294 -480L503 87L506 -81L33 1080H189L577 109H513L871 1080H1021L441 -480H294Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 1080,
    d: "M120 567V693H960V567H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1560,
    d: "M120 567V693H1440V567H120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 443,
    d: "M303 1021Q225 1005 179 1051T133 1189V1440H303V1229H213Q210 1192 214 1160T237 1110T294 1093L303 1021Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 443,
    d: "M140 1020L149 1093Q189 1090 207 1109T229 1160T231 1229H140V1440H311V1189Q311 1097 265 1051T140 1020Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 531,
    d: "M120 -209L129 -136Q169 -139 187 -120T209 -69T211 0H120V211H291V-40Q291 -132 245 -178T120 -209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 745,
    d: "M585 1451L575 1378Q536 1381 518 1362T496 1311T494 1242H585V1031H414V1282Q414 1374 460 1420T585 1451ZM331 1451L321 1378Q282 1381 264 1362T242 1311T240 1242H331V1031H160V1282Q160 1374 206 1420T331 1451Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 745,
    d: "M160 1034L169 1107Q209 1104 227 1123T249 1174T251 1243H160V1454H331V1203Q331 1111 285 1065T160 1034ZM414 1034L423 1107Q463 1104 481 1123T503 1174T505 1243H414V1454H585V1203Q585 1111 539 1065T414 1034Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 745,
    d: "M160 -209L169 -136Q209 -139 227 -120T249 -69T251 0H160V211H331V-40Q331 -132 285 -178T160 -209ZM414 -209L423 -136Q463 -139 481 -120T503 -69T505 0H414V211H585V-40Q585 -132 539 -178T414 -209Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 1307,
    d: "M658 397Q592 397 538 427T452 511T420 630Q420 696 452 749T537 833T658 863Q720 863 772 833T855 750T887 630Q887 564 856 511T772 428T658 397Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 1229,
    d: "M749 161L280 630L749 1099L843 1007L461 630L843 253L749 161Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 1229,
    d: "M479 161L386 253L767 630L386 1007L479 1099L949 630L479 161Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManropeV13LatinRegular);
export default __webpack_public_path__ + "static/media/manrope-v13-latin-regular.f9f7b8f5159c9e3f0157de6c198bf051.svg";
export { ForwardRef as ReactComponent };